import React from 'react'
import styles from './ImageSelection.module.css'

const ImageSelection = ( {name, handleSelection, handleChange, value, id }) => {
    return (
        <div className={styles.selectContainer}>
        <label className={styles.container}>
        <input 
            type="radio"
            name={name} 
            value={value}
            id={id}
            onChange={handleChange || handleSelection}
            
        />
        <span className={styles.checkmark}> <i className="fas fa-arrows-alt-h"></i> </span>
        
    </label >
    </div>
    )
}

export default ImageSelection
